/**
 * Give the browser password manager a chance to offer “Save password”
 * after an SPA auth form that used preventDefault + fetch.
 *
 * Instant location.replace() often cancels that prompt.
 */
export async function storePasswordCredential(email: string, password: string): Promise<void> {
  try {
    if (typeof window === "undefined") return;
    const PasswordCredential = (
      window as Window & {
        PasswordCredential?: new (options: { id: string; password: string }) => Credential;
      }
    ).PasswordCredential;
    if (!PasswordCredential) return;
    const credential = new PasswordCredential({
      id: email.trim(),
      password,
    });
    await navigator.credentials.store(credential);
  } catch {
    // User declined, unsupported, or insecure context — continue sign-in.
  }
}

export async function redirectAfterPasswordAuth(
  email: string,
  password: string,
  redirectTo: string
): Promise<void> {
  await storePasswordCredential(email, password);
  // One frame + short delay so managers that hook form submit can show UI
  // before we tear down the document.
  await new Promise<void>((resolve) => {
    window.requestAnimationFrame(() => {
      window.setTimeout(resolve, 100);
    });
  });
  window.location.assign(redirectTo);
}
